import { FormRow, RadioGroup } from '../../../../Common/Form'
import { Fields } from '../../../../Common/forms'
import { showValidPreserveDays } from '../../../../../lib/formatter'
import PreserveDaysFields from './PreserveDaysFields/PreserveDaysFields'
import Tip from '../../Tip'
import styles from './PreserveDays.css'

const PreserveDays = props => {
  const {
    shipTypeId,
    hasPreserveDays,
    readOnly,
    isNewProposal,
    mustShowFormError,
    handlePreserveDays,
    label = '保存期限',
    tip = null
  } = props

  const preserveDaysformName = `shipType${shipTypeId}PreserveDays`

  return (
    <>
      <FormRow
        key={preserveDaysformName}
        labelAlign='top'
        label={label}
        data-role='preserve-days-formRow'
      >
        <RadioGroup
          key='preserveDays'
          data-role='preserve-days-radio'
          defaultValue={hasPreserveDays}
          value={hasPreserveDays}
          className={styles.hasPreserveDays}
          buttonStyle='outline'
          onChange={handlePreserveDays}
          options={[
            { label: '無', value: false },
            { label: '有', value: true }
          ]}
          disabled={readOnly}
          showErrorOnActive={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
      </FormRow>
      <FormRow
        key='preserveDaysTip'
        className={styles.resetMargin}
        data-role='preserve-days-tip-formRow'
      >
        {
          hasPreserveDays
            ? (
              <>
                {!readOnly && (tip)}
                <div
                  data-role='preserveDays-block'
                  key='preserveDaysBlock'
                  className={styles.preserveDaysBlock}
                >
                  <span key='prefix'>
                    保存天數：
                  </span>
                  <div key='field'>
                    <Fields
                      names={[
                        'setting._preserveDays',
                        'product.preserveDays',
                        'product.years',
                        'product.months',
                        'product.days'
                      ]}
                      data-role='product-preserve-days'
                      component={PreserveDaysFields}
                      readOnly={readOnly}
                      format={showValidPreserveDays}
                      isNewProposal={isNewProposal}
                      mustShowFormError={mustShowFormError}
                    />
                  </div>
                </div>
              </>
            )
            : (
              <Tip
                key='info'
                type='info'
              >
                若您的商品有保存期限，請務必選擇&quot;有&quot;
              </Tip>
            )
        }
      </FormRow>
    </>
  )
}

export default PreserveDays
